export default __webpack_public_path__ + "static/media/Gida of the Ecliptic.0650dbf9.jpg";